import React, { useState, Fragment, useEffect } from 'react';
import Addon from '../../models/Addon';
import { getApi } from '../../api/endpoints';
import { toast } from 'react-toastify';

const FormPartial = (props) => {
  const { addon } = props;
  let addonObj = new Addon(addon);
  const [addonTypesApi] = getApi('addonTypes');
  const [addonTypesOptions, setAddonTypesOptions] = useState({});

  useEffect(() => {
    getAddonTypes();
  }, []);

  const getAddonTypes = async () => {
    try{
      let response = await addonTypesApi({}).unwrap();
      setAddonTypesOptions(response.data.addon_types);
    } catch(error){
      toast.error('Error while fetching Addon Types.')
    }
  }

  const validateValue = (field) => {
    addonObj.validate(field);
  }

  const changeValue = (field, value) => {
    addonObj[field] = value;
    validateValue(field);
    props.setAddon(addonObj.toStateJson());
  }

  return <Fragment>
    <div className="mb-0 col-md-6">
      <label htmlFor="name" className="form-label mb-0">Addon Name</label>
      <input
        value={addon.name}
        onChange={(e) => changeValue('name', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-12"
        id="name"
        aria-describedby="nameHelp"
        placeholder='Enter Addon Name'
      />
      <div id="nameHelp" className="form-text text-danger mt-0">
        {addon.errors.name}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="addon_type" className="form-label mb-0">Addon Type</label>
      <select
        id="addon_type"
        onChange={(e) => changeValue('addon_type', e.target.value)}
        className="form-control form-control-sm font-size-12"
        aria-describedby="addon_type_help"
        value={addonObj.addon_type}
      >
      <option disabled value="">Select Addon type</option>
      {addonTypesOptions && Object.keys(addonTypesOptions).map(key => (
        <option key={key} value={key}>{key.replace('_', ' ').replace(/\b\w/g, char => char.toUpperCase())}</option>
      ))}
      </select>
      <div id="addon_type_help" className="form-text text-danger mt-0">
        {addon.errors.addon_type}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="price" className="form-label mb-0">Price</label>
      <input
        value={addon.price}
        onChange={(e) => changeValue('price', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-12"
        id="price"
        aria-describedby="priceHelp"
        placeholder="Enter price"
      />
      <div id="priceHelp" className="form-text text-danger mt-0">
        {addon.errors.price}
      </div>
    </div>
    <div className="mb-0 col-md-3">
      <label htmlFor="swap_count_validity" className="form-label mb-0">Swap Counts</label>
      <input
        value={addon.swap_count_validity}
        onChange={(e) => changeValue('swap_count_validity', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-12"
        id="swap_count_validity"
        aria-describedby="swap_count_validityHelp"
        placeholder='Enter Swap Counts'
      />
      <div id="swap_count_validityHelp" className="form-text text-danger mt-0">
        {addon.errors.swap_count_validity}
      </div>
    </div>
    <div className="mb-0 col-md-3">
      <label htmlFor="time_validity" className="form-label mb-0">Validity Days</label>
      <input
        value={addon.time_validity}
        onChange={(e) => changeValue('time_validity', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-12"
        id="time_validity"
        aria-describedby="time_validityHelp"
        placeholder='Enter Validity Days'
      />
      <div id="time_validityHelp" className="form-text text-danger mt-0">
        {addon.errors.time_validity}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="description" className="form-label mb-0">Description</label>
      <textarea
        value={addon.description}
        onChange={(e) => changeValue('description', e.target.value)}
        type="textarea"
        className="form-control form-control-sm font-size-12"
        id="description"
        aria-describedby="addonDescriptionHelp"
        placeholder='Enter Addon Description'
      />
      <div id="addonDescriptionHelp" className="form-text text-danger mt-0">
        {addon.errors.description}
      </div>
    </div>
  </Fragment>
}

export default FormPartial;
